<h2 mat-dialog-title>Confirmar Receção de Encomendas</h2>
<mat-dialog-content>
  <div class="child-orders-list">
    @for (child of childOrders; track child) {
      <div class="child-order-item">
        <div class="child-order-info">{{ child.nome }}</div>
        @if (child.estado === 'Recebida') {
          <div class="received-status">
            <mat-icon class="success-icon" fontSet="material-icons">check_circle</mat-icon>
            Recebida
          </div>
        } @else {
          <button
            mat-raised-button
            color="primary"
            [disabled]="child.estado !== 'Enviada'"
            (click)="confirmReception(child)"
            >
            Confirmar Receção
          </button>
        }
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Fechar</button>
</mat-dialog-actions>